import { action } from '@reatom/framework'

import { WeakRegistry } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { environmentAtom } from '@root/shared/environment'

import { CurrencyAddress, CurrencyModel, CurrencyRef } from '../model'

import type { ServicesApi, WalletApi } from '@root/shared/api'

export class CurrencyRegistry {
  private registry = new WeakRegistry<string, CurrencyModel>()

  private mkKey = (ref: CurrencyRef.Ref) => {
    return `curr:${CurrencyRef.toString(ref)}`
  }

  public get = (address: CurrencyAddress, network: Network.Network) => {
    const key = this.mkKey({ address, network })
    return this.registry.get(key)
  }
  public getOrCreate = (
    address: CurrencyAddress,
    network: Network.Network,
    factory: () => CurrencyModel,
  ) => {
    const key = this.mkKey({ address, network })
    return this.registry.getOrCreate(key, factory)
  }
  public resolveFromTokenMeta = action(
    (ctx, tokenMeta: ServicesApi.TokenMetaDto) => {
      const {
        assets: { tokenLogosHost },
      } = ctx.get(environmentAtom)
      return this.getOrCreate(
        CurrencyAddress(tokenMeta.address),
        Network.fromDto(tokenMeta.network),
        () => CurrencyModel.fromTokenMeta(tokenMeta, tokenLogosHost),
      )
    },
  )
  public resolveFromWalletAsset = action(
    (ctx, tokenMeta: WalletApi.WalletAssetDto, network: Network.Network) => {
      const {
        assets: { tokenLogosHost },
      } = ctx.get(environmentAtom)
      return this.getOrCreate(CurrencyAddress(tokenMeta.address), network, () =>
        CurrencyModel.fromWalletAssetDto(tokenMeta, tokenLogosHost, network),
      )
    },
  )
  public set = (currency: CurrencyModel) => {
    const key = this.mkKey(currency)
    this.registry.set(key, currency)
  }
}

export const currencyRegistry = new CurrencyRegistry()

// eslint-disable-next-line @reatom/unit-naming-rule
export const currencyDtoUpdatedEvent = action<ServicesApi.TokenMetaDto>(
  'currencyDtoUpdatedEvent',
)

currencyDtoUpdatedEvent.onCall((ctx, _, [tokenMeta]) => {
  const currency = currencyRegistry.resolveFromTokenMeta(ctx, tokenMeta)
  currency.updateFromTokenMeta(ctx, tokenMeta)
})
